import React from 'react';
export default () => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 7.275L0 0H18L9 7.275ZM4.95 5.925L0 1.95V11.325L4.95 5.925ZM13.05 5.925L18 11.325V1.95L13.05 5.925ZM11.925 6.9L9 9.225L6.075 6.9L0 13.5H18L11.925 6.9Z"
      fill="black"
      fillOpacity="0.2"
    />
  </svg>
);
